<template>
    <div class="main-layout__container">
        <div class="content__header">
            <div class="content-header__title">Модели</div>

            <div class="content-header__actions">
                <router-link :to="{ name: 'AddModel' }">
                    <UISimpleButton>
                        <template #icon>
                            <img src="@/assets/icons/ui/plus-white.svg" />
                        </template>
                        Добавить
                    </UISimpleButton>
                </router-link>
            </div>

            <div class="content-header__background content-header__background--2-lines-filters"></div>
        </div>

        <UITabs v-model="activeTab">
            <UITab name="hyundai" label="Hyundai">
                <HandbookModelsTab :brand-id="1" />
            </UITab>

            <UITab name="genesis" label="Genesis">
                <HandbookModelsTab :brand-id="2" />
            </UITab>
        </UITabs>
    </div>
</template>

<script lang="ts" setup>
    import { Ref, ref } from 'vue';
    import { useRoute } from 'vue-router';

    import { injectStrict } from '@/injection/injectStrict.ts';
    import { PagePropertiesKey } from '@/injection/keys.ts';

    import { PageProperties } from '@/types/page-properties.type.ts';

    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';
    import UITab from '@/components/ui/UITab/UITab.vue';
    import UITabs from '@/components/ui/UITabs/UITabs.vue';

    import HandbookModelsTab from '@/views/handbooks/HandbookModels/components/HandbookModelsTab/HandbookModelsTab.vue';

    const $PageProperties: Ref<PageProperties> = injectStrict<Ref<PageProperties>>(PagePropertiesKey);

    const route = useRoute();

    const brand: string = (route.params.brand as string) || 'hyundai';

    if (!['hyundai', 'genesis'].includes(brand)) {
        $PageProperties.value.notFound = true;
    }

    const activeTab = ref(brand);
</script>

<style lang="scss" scoped>
    @use 'HandbookModels' as *;
</style>
